/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsInfoData } from './lds-info.data';
import { ILdsInfoProps } from './lds-info.props.autogenerated';

export interface ILdsInfoViewProps extends ILdsInfoProps<ILdsInfoData> {}

/**
 *
 * LdsWarn component
 * @extends {React.PureComponent<ILdsInfoProps<ILdsInfoData>>}
 */
class LdsWarn extends React.PureComponent<ILdsInfoProps<ILdsInfoData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsWarn;
